import React from "react";

const CategorySelect = ({
    mainCategory, setMainCategory, mainCategories,
    subCategory, setSubCategory, subCategories,
    detailCategory, setDetailCategory, detailCategories
}) => {

    const reference = 3;

    const handleMainCategoryChange = (e) => {
        const newVal = e.target.value;
        setMainCategory(newVal);
        setSubCategory('0');
        setDetailCategory('0');
    };

    const handleSubCategoryChange = (e) => {
        const newVal = e.target.value;
        setSubCategory(newVal);
        setDetailCategory('0');
    };

    const handleDetailCategoryChange = (e) => {
        setDetailCategory(e.target.value);
    };

    const mainOptions = [
        { value: '0', label: '대분류' },
        ...mainCategories.map(cat => ({
            value: cat.biz_main_category_id,
            label: `${cat.biz_main_category_name} (${cat.biz_sub_category_count})`,
        })),
    ];

    const filteredSubCategories = reference === 3
        ? subCategories.filter(cat => typeof cat.biz_sub_category_id === 'string' && cat.biz_sub_category_id.startsWith(mainCategory))
        : subCategories;

    const subOptions = [
        { value: '0', label: '중분류' },
        ...filteredSubCategories.map(cat => ({
            value: cat.biz_sub_category_id,
            label: `${cat.biz_sub_category_name} (${cat.biz_detail_cateogry_count})`,
        })),
    ];

    const filteredDetailCategories = reference === 3
        ? detailCategories.filter(cat => typeof cat.biz_detail_category_id === 'string' && cat.biz_detail_category_id.startsWith(subCategory))
        : detailCategories;

    const detailOptions = [
        { value: '0', label: '소분류' },
        ...filteredDetailCategories.map(cat => ({
            value: cat.biz_detail_category_id,
            label: cat.biz_detail_category_name,
        })),
    ];

    return (
        <div className="flex gap-4 w-full">
            <select
                value={mainCategory}
                onChange={handleMainCategoryChange}
                disabled={reference === '0'}
                className="p-3 text-sm border border-[#DDDDDD] rounded w-1/3 flex-1 block bg-white"
            >
                {mainOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>

            <select
                value={subCategory}
                onChange={handleSubCategoryChange}
                disabled={mainCategory === '0'}
                className="p-3 text-sm border border-[#DDDDDD] rounded w-1/3 flex-1 block bg-white"
            >
                {subOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>

            <select
                value={detailCategory}
                onChange={handleDetailCategoryChange}
                disabled={subCategory === '0'}
                className="p-3 text-sm border border-[#DDDDDD] rounded w-1/3 flex-1 block bg-white"
            >
                {detailOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CategorySelect;
